import React, { FC, useState } from "react";

import clsx from "clsx";
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";

import { HelpIcon } from "@/assets/icons";
import { StyledHeaderMenuButton } from "@/components/layouts/styled";
import config from "@/config";
import { sanitizeHtml, sanitizeUrl } from "@/core/security";

import { StyledHelpPopover } from "./styled";

const Help: FC = () => {
    const theme = useTheme();
    const isMobileScreen = useMediaQuery(theme.breakpoints.down("sm"));
    const { t } = useTranslation();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? "simple-popover" : undefined;

    //------------------------------------------------------

    return (
        <>
            <StyledHelpPopover
                classes={{ paper: "popover-paper" }}
                className="helpDialogBox"
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={
                    !isMobileScreen
                        ? {
                              vertical: "bottom",
                              horizontal: "right",
                          }
                        : { vertical: "bottom", horizontal: "center" }
                }
                transformOrigin={
                    !isMobileScreen
                        ? {
                              vertical: "top",
                              horizontal: "right",
                          }
                        : { vertical: "top", horizontal: "center" }
                }
            >
                <Typography className="helpTitle">{t("NavBar.Help.HelpTitle")}</Typography>
                <Typography className="helpMessage">
                    <span>{t("NavBar.Help.HelpMessage")}</span>
                    <a
                        dangerouslySetInnerHTML={{ __html: sanitizeHtml(t("NavBar.Help.HelpNumber")) }}
                        className={clsx(!isMobileScreen && "isDisabled")}
                        href={`tel:${sanitizeUrl(config.HELP_PHONE_NUMBER)}`}
                    />
                </Typography>
            </StyledHelpPopover>

            <StyledHeaderMenuButton
                aria-controls={id}
                data-testid="help-button-help"
                $active={!!anchorEl}
                onClick={handleClick}
                title={t("Common.Help")}
            >
                <div className={clsx("icon", anchorEl && "active")}>
                    <HelpIcon />
                </div>
            </StyledHeaderMenuButton>
        </>
    );
};

export default Help;
